/**
 * en-GB messages added by Phase 3 task M6 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const m6EnGB = {
    'companion.p3.work.menu_scan': 'Scan a sign-in point',
    'companion.p3.work.refresh': 'Refresh',
    'companion.p3.work.cancel': 'Cancel',
    'companion.p3.work.done': 'Done',
    'companion.p3.work.hide': 'Hide',
    'companion.p3.work.details': 'Details',
    'companion.p3.work.needs_signal': 'No signal. This needs a connection, so it will not update until you are back online.',
    'companion.p3.work.sign_pad': 'Signature box. Draw your signature with your finger.',
    'companion.p3.work.sign_clear': 'Clear signature',
    'companion.p3.work.sign_name': 'Your full name',
    // Parcels
    'companion.p3.work.parcels_title': 'My parcels',
    'companion.p3.work.parcels_none': 'You have no parcels.',
    'companion.p3.work.parcels_waiting': 'You have {count} to collect.',
    'companion.p3.work.parcels_unknown_carrier': 'Parcel',
    'companion.p3.work.parcels_count': 'Parcels: {count}',
    'companion.p3.work.parcels_location': 'Left at: {location}',
    'companion.p3.work.parcel_status_waiting': 'Waiting for you',
    'companion.p3.work.parcel_status_collected': 'Collected',
    'companion.p3.work.parcel_status_returned': 'Returned',
    'companion.p3.work.parcel_status_cancelled': 'Cancelled',
    // Permits
    'companion.p3.work.permits_title': 'My permits',
    'companion.p3.work.permits_none': 'You have no permits to work.',
    'companion.p3.work.permit_status_requested': 'Requested',
    'companion.p3.work.permit_status_issued': 'Issued',
    'companion.p3.work.permit_status_active': 'Active',
    'companion.p3.work.permit_status_suspended': 'Suspended',
    'companion.p3.work.permit_status_closed': 'Closed',
    'companion.p3.work.permit_status_cancelled': 'Cancelled',
    'companion.p3.work.permit_status_expired': 'Expired',
    'companion.p3.work.permit_area': 'Area: {area}',
    'companion.p3.work.permit_times': 'From {from} to {to}',
    'companion.p3.work.permit_suspended': 'Work must stop. Reason: {reason}',
    'companion.p3.work.permit_needs_accept': 'Read the conditions, then accept and sign before you start work.',
    'companion.p3.work.permit_needs_close': 'Work finished? Sign to say it is complete.',
    'companion.p3.work.permit_review_accept': 'Read and accept',
    'companion.p3.work.permit_review_close': 'Sign off the work',
    'companion.p3.work.permit_conditions': 'Conditions',
    'companion.p3.work.permit_checklist': 'Checks',
    'companion.p3.work.permit_accept_title': 'Accept this permit',
    'companion.p3.work.permit_accept_help': 'By signing you confirm you have read the conditions and will follow them.',
    'companion.p3.work.permit_close_title': 'Sign off the work',
    'companion.p3.work.permit_close_help': 'By signing you confirm the work is finished and the area is safe.',
    'companion.p3.work.permit_accept': 'Accept and sign',
    'companion.p3.work.permit_close': 'Sign off',
    // Documents
    'companion.p3.work.documents_title': 'My documents',
    'companion.p3.work.documents_none': 'No documents are needed from you.',
    'companion.p3.work.documents_induction_note': 'You also need to complete an induction. See My inductions.',
    'companion.p3.work.doc_state_valid': 'Valid',
    'companion.p3.work.doc_state_expiring': 'Expiring soon',
    'companion.p3.work.doc_state_expired': 'Expired',
    'companion.p3.work.doc_state_missing': 'Missing',
    'companion.p3.work.doc_state_pending_review': 'Waiting for review',
    'companion.p3.work.doc_state_rejected': 'Rejected',
    'companion.p3.work.doc_status_pending_review': 'Waiting for review',
    'companion.p3.work.doc_status_valid': 'Valid',
    'companion.p3.work.doc_status_rejected': 'Rejected',
    'companion.p3.work.doc_status_superseded': 'Replaced',
    'companion.p3.work.doc_expires': 'Expires {date}',
    'companion.p3.work.doc_rejected': 'Not accepted: {reason}',
    'companion.p3.work.doc_sent_title': 'Sent by you',
    'companion.p3.work.doc_sent': '{name} sent. It will show once it has been checked.',
    'companion.p3.work.doc_upload': 'Upload a photo',
    'companion.p3.work.doc_form_help': 'Take a clear photo of the whole document. Dates are optional, written like 2027-01-31.',
    'companion.p3.work.doc_photo': 'Take a photo',
    'companion.p3.work.doc_retake': 'Take it again',
    'companion.p3.work.doc_photo_none': 'No photo yet.',
    'companion.p3.work.doc_photo_ready': 'Photo ready.',
    'companion.p3.work.doc_camera_help': 'Hold the phone steady over the document.',
    'companion.p3.work.doc_take': 'Take photo',
    'companion.p3.work.doc_camera_failed': 'The photo could not be taken. Please try again.',
    'companion.p3.work.doc_camera_denied': 'Camera access is off. Turn it on in the phone settings.',
    'companion.p3.work.doc_reference': 'Reference or number (optional)',
    'companion.p3.work.doc_issue': 'Issue date (optional)',
    'companion.p3.work.doc_expiry': 'Expiry date (optional)',
    'companion.p3.work.doc_send': 'Send document',
    'companion.p3.work.doc_err_issue_date': 'The issue date must be a real date like 2026-01-31.',
    'companion.p3.work.doc_err_expiry_date': 'The expiry date must be a real date like 2027-01-31.',
    'companion.p3.work.doc_err_order': 'The expiry date cannot be before the issue date.',
    // Inductions
    'companion.p3.work.inductions_title': 'My inductions',
    'companion.p3.work.inductions_none': 'You have no inductions to take.',
    'companion.p3.work.induction_summary': '{questions} questions. Pass mark {pass}%.',
    'companion.p3.work.induction_start': 'Start',
    'companion.p3.work.induction_watch_first': 'Watch the video first. The questions open after {seconds} more seconds of playing.',
    'companion.p3.work.induction_open_pdf': 'Open the document',
    'companion.p3.work.induction_pick_one': 'Choose one answer.',
    'companion.p3.work.induction_pick_many': 'Choose all that apply.',
    'companion.p3.work.induction_submit': 'Submit answers',
    'companion.p3.work.induction_passed': 'Passed',
    'companion.p3.work.induction_failed': 'Not passed this time',
    'companion.p3.work.induction_score': 'You scored {score}%. The pass mark is {pass}%.',
    'companion.p3.work.induction_until': 'Valid until {date}.',
    'companion.p3.work.induction_wrong': 'Check question {numbers}.',
    'companion.p3.work.induction_retry': 'Try again',
    // Sign-in point scan and phone tap
    'companion.p3.work.scan_title': 'Scan a sign-in point',
    'companion.p3.work.scan_intro': 'Scan the code on the sign-in point poster to sign in or out.',
    'companion.p3.work.scan_help': 'Point the camera at the code on the poster.',
    'companion.p3.work.scan_button': 'Scan the code',
    'companion.p3.work.scan_denied': 'Camera access is off. Turn it on in the phone settings.',
    'companion.p3.work.scan_not_ours': 'That is not a sign-in point code.',
    'companion.p3.work.scan_signed_in': 'Signed in at {site}',
    'companion.p3.work.scan_signed_out': 'Signed out of {site}',
    'companion.p3.work.tap_title': 'Tap your phone',
    'companion.p3.work.tap_help': 'Sign in by tapping your phone on the kiosk reader.',
    'companion.p3.work.tap_switch': 'Use my phone as a tap card',
    'companion.p3.work.tap_unavailable': 'Phone tap is not available on this phone yet. Show your QR code at the kiosk instead.',
};
//# sourceMappingURL=m6.js.map